import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { subDays } from "date-fns";

export const useShowcasePageViews = (organizationId: string) => {
  return useQuery({
    queryKey: ['showcase-page-views', organizationId],
    queryFn: async () => {
      const sevenDaysAgo = subDays(new Date(), 7).toISOString();

      const [totalResult, uniqueResult, recentResult] = await Promise.all([
        supabase
          .from('showcase_page_views')
          .select('id', { count: 'exact', head: true })
          .eq('organization_id', organizationId),
        supabase
          .from('showcase_page_views')
          .select('ip_hash')
          .eq('organization_id', organizationId),
        supabase
          .from('showcase_page_views')
          .select('id', { count: 'exact', head: true })
          .eq('organization_id', organizationId)
          .gte('viewed_at', sevenDaysAgo),
      ]);

      const uniqueIps = new Set(uniqueResult.data?.map(r => r.ip_hash).filter(Boolean));

      return {
        totalViews: totalResult.count ?? 0,
        uniqueVisitors: uniqueIps.size,
        last7Days: recentResult.count ?? 0,
      };
    },
    enabled: !!organizationId,
    staleTime: 60 * 1000,
  });
};
